import { useNavigate } from "react-router-dom";
import LargeItemCard from "./base/LargeItemCard.jsx";

export default function RaceItem({event_id, race, idx, orgId = null}) {

    const navigate = useNavigate();

    if (!race) return null;

    const handleRaceClick = (event_id, race) => {    
    navigate(`/events/${event_id}/races/${race.id_bdd}`, { state: { race, orgId } });
};

    const name= race.name || "Unnamed Race";
    const eventType = race.sport || "Event";
    
    // Get extra info details
    const extraInfo = race.extra_info || {};
    
    // Get all distance columns from extra_info and sum their values
    const distanceColumns = Object.entries(extraInfo)
      .filter(([key]) => key.toLowerCase().includes("distance"))
      .map(([key, value]) => parseFloat(value) || 0);
    
    const distanceSum = distanceColumns.reduce((acc, val) => acc + val, 0);
    const distanceDisplay = distanceSum > 0 ? `${distanceSum} km` : null;
    
    // Get all elevation columns from extra_info and sum their values
    const elevationColumns = Object.entries(extraInfo)
      .filter(([key]) => key.toLowerCase().includes("elevation"))
      .map(([key, value]) => parseFloat(value) || 0);
    
    const elevationSum = elevationColumns.reduce((acc, val) => acc + val, 0);
    
    // Add fallback elevation if no extra_info elevations found
    const elevationDisplay = elevationSum > 0 ? `${elevationSum} m D+` : null;
    
  
  return (
    <LargeItemCard key={idx} onClick={() => handleRaceClick(event_id, race)} justify={true}>
        <div>
        <p style={styles.raceName}>{name}</p>
        <p style={styles.raceInfo}>
          {eventType}
          {distanceDisplay && <span> • Distance: {distanceDisplay}</span>}
          {elevationDisplay && <span> • Dénivelé: {elevationDisplay}</span>}
        </p>
        </div>
        <span style={{
          ...styles.raceStatus,
          ...(race.active === false ? styles.inactiveStatus : (race.available < 0 ? styles.soldOutStatus : {}))
        }}>
          {race.active === false ? "Inactive" : (race.available >= 0 ? "Disponible" : "Complet")}
        </span>
    </LargeItemCard>
  );
}

const styles = {
  raceName: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#1a1a1a",
    margin: "0 0 4px 0",
  },
  raceType: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#666",
    margin: "0 0 6px 0",
  },
  raceInfo: {
    fontSize: "12px",
    margin: "2px 0",
    fontWeight: "500",
    color: "#666"
  },
  raceStatus: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#4CAF50",
    backgroundColor: "#e8f5e9",
    padding: "4px 12px",
    borderRadius: "16px",
  },
  inactiveStatus: {
    color: "#999",
    backgroundColor: "#f5f5f5",
  },
  soldOutStatus: {
    color: "#d32f2f",
    backgroundColor: "#ffebee",
  },
};